import React, { useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination, EffectFade } from "swiper/modules";
import { Link } from "react-router-dom";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import "./Banner.css";
import IMAGE_URL from "Utilities/IMAGE_URL";

const Banner = ({ data }) => {
  const swiperRef = useRef(null);
  const { t } = useTranslation();

  return (
    <div className="banner-container">
      <Swiper
        ref={swiperRef}
        modules={[Autoplay, Navigation, Pagination, EffectFade]}
        spaceBetween={0}
        slidesPerView={1}
        effect="fade"
        speed={1200}
        fadeEffect={{
          crossFade: true,
        }}
        pagination={{
          clickable: true,
          renderBullet: function (index, className) {
            return (
              '<span class="' + className + ' custom-pagination-bullet"></span>'
            );
          },
        }}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        className="w-full h-full banner-swiper"
      >
        {data?.map((slide) => (
          <SwiperSlide key={slide._id}>
            <div className="relative w-full h-[550px] overflow-hidden">
              <img
                src={`${IMAGE_URL}/${slide.image}`}
                alt={slide.title}
                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
              />
              {/* Dark gradient overlay */}
              <div className="absolute inset-y-0 left-0 w-1/2 bg-gradient-to-r from-black/80 to-transparent"></div>
              <div className="absolute inset-0 flex items-center justify-start">
                <div className="text-left px-12 md:px-16 lg:px-20 transform transition-all duration-500 w-full ">
                  <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 drop-shadow-lg font-title lg:w-1/2">
                    {slide.title}
                  </h2>
                  {slide.connection && (
                    <Link
                      to={
                        slide.connection.type === "course"
                          ? `/course-detailes/${slide.connection.slug}`
                          : slide.connection.type === "product"
                          ? `/product/${slide.connection.slug}`
                          : `/book/${slide.connection.slug}`
                      }
                      className="inline-block mt-3 px-12 py-1 bg-primary text-white font-semibold rounded-md hover:bg-opacity-90 transition-all duration-300"
                    >
                      {slide.connection.type === "course"
                        ? t("common.social.viewCourse")
                        : slide.connection.type === "product"
                        ? t("common.social.viewProduct")
                        : t("common.social.viewBook")}
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Banner;
